import { Action, IOWidget, mk_widget } from 'widgets-for-react'
import React from 'react'

import { CMSState } from '../types.gen'
import { getClassName } from '../utils.gen'

export type IframeBlockProps = {
  link: string
}

export type IframeBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  media_classname: string
  video_classname: string
}>

export function IframeBlock<CustomBlockData, extra_images>(
  props: IframeBlockProps,
  options?: { style?: IframeBlockStyle; key?: string }
): IOWidget<CMSState<CustomBlockData, extra_images, never>, Action<CMSState<CustomBlockData, extra_images, never>>> {
  return (s: CMSState<CustomBlockData, extra_images, never>) =>
    mk_widget({
      run: onDone => (
        <section
          className={getClassName(options, 'block_classname', 'container')}
          key={options && options.key ? options.key : 'iframe-block'}
        >
          <div className={getClassName(options, 'inner_classname', 'py-5')}>
            <div className={getClassName(options, 'media_classname', '')}>
              <iframe className={getClassName(options, 'video_classname', '')} src={props.link} />
            </div>
          </div>
        </section>
      )
    })
}
